/**
 * ClientFacingError is thrown when an error should be shown to the user
 * instead of the generic "An internal error occurred" message.
 * Use this sparingly and only for messages that are safe and helpful for end users.
 *
 * @param clientMessage - User-friendly error message
 * @param code - Error code for programmatic detection (e.g., "rate-limit")
 * @param data - Contextual data specific to the error code
 */
export class ClientFacingError extends Error {
	constructor(
		public readonly clientMessage: string,
		public readonly code?: string,
		public readonly data?: unknown,
	) {
		super(clientMessage);
		this.name = "ClientFacingError";
	}
}
